import NewItem from '../common/NewsItem';
import ArrowLeftIcon from '../svg/ArrowLeftIcon';

export default function NotificationModal({
  newNotifications,
  oldNotifications,
  updateNotificationStatus,
  onClose,
}) {
  return (
    <div>
      <div className="fixed z-50 inset-0 bg-black opacity-30 w-full h-full"></div>
      <div className="z-51 fixed inset-0 flex items-center justify-center">
        <div className="w-full mx-4 md:mx-0 md:w-[614px] bg-white rounded-xl shadow-xl rounded-[20px]">
          <div className="p-6">
            <div className="flex items-center py-2 space-x-2">
              <button onClick={onClose} className="cursor-pointer">
                <ArrowLeftIcon size="w-[24px] h-[24px]" color="#092F7B" />
              </button>
              <p className="text-lg text-[#181D27] font-semibold leading-[20px]">
                Notificaciones
              </p>
              <div className="bg-[#ECFDF3] leading-[28px] rounded-[54px] flex items-center justify-center px-2 py-1 space-x-2">
                <div className="w-2 h-2 rounded-full bg-[#12B76A]"></div>
                <p className="text-xs text-[#12B76A] font-normal">{`${newNotifications.length} nuevas`}</p>
              </div>
            </div>
          </div>

          <div className="max-h-[calc(100vh-200px)] overflow-y-auto">
            <div className="px-6 space-y-2">
              {newNotifications.map((item, idx) => (
                <NewItem
                  key={idx}
                  {...item}
                  updateNotificationStatus={updateNotificationStatus}
                />
              ))}
            </div>

            <div className="border-b-1 border-b-[#E9EAEB] my-6"></div>

            <div className="px-6 space-y-2">
              {oldNotifications.map((item, idx) => (
                <NewItem
                  key={idx}
                  {...item}
                  updateNotificationStatus={updateNotificationStatus}
                />
              ))}
            </div>
          </div>

          <div className="h-10"></div>
        </div>
      </div>
    </div>
  );
}
